export default __webpack_public_path__ + "static/media/apple-app-store.a8ee14d3.svg";